import {Injectable} from "@angular/core";
import {FormDto} from "../../core/interfaces/core.types";
import {SignatureDto} from "../../cross/user-signatures/type/user-signatures.types";

@Injectable({ providedIn: 'root' })
export abstract class SignUpService {

  phoneNumber: string | undefined;
  registrationGuid: string | undefined;
  registrationForm: FormDto | undefined | any;
  signatures: SignatureDto[] | undefined;
  selectedOtpOption: number | undefined;

  backClick: boolean = false;

  start() {
    this.phoneNumber = undefined;
    this.registrationForm = undefined;
    this.registrationGuid = undefined;
    this.selectedOtpOption = undefined;
  }

  setBackClicked(value: boolean) {
    this.backClick = value;
  }

  getBackClick(): boolean {
    return this.backClick;
  }
}
